<script setup lang="ts">
defineProps<{
  label: string
  name?: string
  required?: boolean
}>()

const checked = ref(false)
</script>

<template>
  <div>
    <label :for="name" class="flex items-center gap-3 text-xs">
      <div class="flex size-5 shrink-0 items-center justify-center border border-black/50">
        <IconsLogomark class="size-3" :class="checked ? 'opacity-100' : 'opacity-0'" />
      </div>

      {{ label }}
    </label>

    <input
      :id="name"
      v-model="checked"
      :name="name"
      :required="required"
      type="checkbox"
      class="sr-only"
    />
  </div>
</template>
